import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Agencies, AgenciesOperators, AllStopsNBIQ, StopPredictions, Stop, StopsNBIQ } from '../types/types';
import { AppConfigService } from './app-config/app-config.service';

@Injectable({
  providedIn: 'root'
})

export class MapsService {
  nearbyAppKeys: any = {};
  constructor(
    private httpClient: HttpClient,
    private appConfigService: AppConfigService
  ) {
  this.nearbyAppKeys = this.appConfigService.getConfig();
  }

  stopsParams = {
    params: new HttpParams().set('format', 'json')
  };

  stopsIqParams = {
    params: new HttpParams()
  };

  getOperators(): Observable<AgenciesOperators> {
    return this.httpClient.get<AgenciesOperators>(this.nearbyAppKeys.baseUrl + '/operators', { params: this.stopsParams.params.set('api_key', this.nearbyAppKeys.api_key)});
  }

  getStops(operatorId: string, stopCode: string): Observable<Stop> {
    return this.httpClient.get<Stop>(this.nearbyAppKeys.baseUrl + '/stopPlaces', { params: this.stopsParams.params.set('api_key', this.nearbyAppKeys.api_key).set('operator_id', operatorId).set('stop_id', stopCode)});
  }

  stopPredictions(agency: string, stopCode: string): Observable<StopPredictions> {
    return this.httpClient.get<StopPredictions>(this.nearbyAppKeys.baseUrl + '/StopMonitoring', { params: this.stopsParams.params.set('api_key', this.nearbyAppKeys.api_key).set('agency', agency).set('stopCode', stopCode) });
  }

  getAgencies(stopName: string): Observable<Agencies> {
    return this.httpClient.get<Agencies>(this.nearbyAppKeys.nb_iq_baseUrl + 'agencies', {params: this.stopsIqParams.params.set('agency', stopName)});
  }

  getStopsNbIq(operatorId: string, stopCode: string): Observable<StopsNBIQ> {
    return this.httpClient.get<StopsNBIQ>(this.nearbyAppKeys.nb_iq_baseUrl + 'stopcodeNbIq', { params: this.stopsIqParams.params.set('agency', operatorId).set('stopCode', stopCode)});
  }

  stopPredictionsNbIq(agency: string, stopCodes: string): Observable<AllStopsNBIQ> {
    return this.httpClient.get<AllStopsNBIQ>(this.nearbyAppKeys.nb_iq_baseUrl + 'stopPredictionsNbIq', { params: this.stopsIqParams.params.set('agency', agency).set('stopCode', stopCodes)});
  }

  public sendEmail(error: any): Observable<any> {
    const notificationData = {
      errors: error
    };
    return this.httpClient.post<any>(this.nearbyAppKeys.nb_iq_baseUrl + 'sendEmail', notificationData);
  }

}
